import { createRouter, createWebHistory } from "vue-router";
import store from "../store";

import Dashboard from "../views/Dashboard.vue";
import Signin from "../views/login/Signin.vue";
import Signout from "../views/Signout.vue";

import AccessGroupManager from "../views/accessGroup/AccessGroupManager.vue";
import AccessGroupAdd from "../views/accessGroup/AccessGroupAdd.vue";
import AccessGroupEdit from "../views/accessGroup/AccessGroupEdit.vue";

import Profile from "@/views/Person/Profile.vue";

// START Base Information

import School from "../views/School/MainForm.vue";
import SchoolActivity from "../views/School/MainForm.vue";

// END Base Information

import CartabelForm from "../views/Cartabel/Manager.vue";

import SubmitTicketForm from "@/views/Ticket/SubmitTicketForm.vue";
import TicketList from "@/views/Ticket/TicketList.vue";
import TicketDetails from "@/views/Ticket/TicketDetails.vue";
import UserForm from "@/views/User/UserForm.vue";
import UserAccessGroups from "@/views/User/UserAccessGroups.vue";
import PermissionForm from "@/views/Permission/PermissionForm.vue";
import UserRepassForm from "@/views/User/UserRepassForm.vue";
import UserList from "@/views/User/UserList.vue";
import PermissionList from "@/views/Permission/PermissionList.vue";
import CompanyList from "@/views/Company/CompanyList.vue";
import CustomerList from "@/views/Customer/CustomerList.vue";
import CompanyForm from "@/views/Company/CompanyForm.vue";
import CustomerForm from "@/views/Customer/CustomerForm.vue";
import CompanySectionForm from "@/views/Company/CompanySectionForm.vue";
import SectionCustomerManager from "@/views/Company/SectionCustomerManager.vue";
import CompanyReferralBaseForm from "../views/Company/CompanyReferralBaseForm.vue";
import CompanySectionList from "@/views/Company/CompanySectionList.vue";
import RoleForm from "@/views/Role/RoleForm.vue";
import RoleList from "@/views/Role/RoleList.vue";
import UserRoleForm from "@/views/Role/ShowAccessGroupMember.vue";
import ComprehensiveReport from "../views/Report/ComprehensiveReport/ComprehensiveReport.vue";

const routeGroup = {
  baseInfoGroup: 'baseInfoGroup',
  report: 'report',
  school: 'school',
  ticket: 'ticket',
  users: 'users',
  companies: 'companies',
  customers: 'customers',
  sections: 'sections',
  roles: 'roles',
  permissions: 'permissions'
};

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/main",
    meta: {
      routeGroups: routeGroup
    }
  },

  {
    path: "/main",
    name: "صفحه اصلی",
    component: Dashboard,
  },
  {
    path: "/cartabel",
    name: "تایید اطلاعات",
    component: CartabelForm,
  },

  //Ticket
  {
    path: "/submitTicket",
    name: "ثبت تیکت",
    component: SubmitTicketForm,
    meta: {
      new: true,
      routeGroups: routeGroup.ticket
    }
  },
  {
    path: "/myTickets",
    name: "تیکت‌های من",
    component: TicketList,
    meta: {
      listOf: 'submited',
      routeGroups: routeGroup.ticket
    }
  },
  {
    path: "/referredTickets",
    name: "تیکت‌های ارجاعی",
    component: TicketList,
    meta: {
      listOf: 'referred',
      routeGroups: routeGroup.ticket
    }
  },
  {
    path: "/allTickets",
    name: "همه تیکت‌ها",
    component: TicketList,
    meta: {
      listOf: 'all',
      routeGroups: routeGroup.ticket
    }
  },
  {
    path: "/bookmarkedTickets",
    name: "تیکت های نشان شده",
    component: TicketList,
    meta: {
      listOf: 'bookmarked',
      routeGroups: routeGroup.ticket
    }
  },
  {
    path: "/ticketDetails/:ticketId",
    name: "جزئیات تیکت",
    component: TicketDetails,
    meta: {
      routeGroups: routeGroup.ticket
    }
  },

  //Report
  {
    path: "/comprehensiveReport",
    name: "گزارش جامع",
    component: ComprehensiveReport,
    meta: {
      group: routeGroup.report
    }
  },

  //User
  {
    path: "/AddUser",
    name: "افزودن کاربر جدید",
    component: UserForm,
    meta: {
      new: true,
      group: routeGroup.users
    }
  },
  {
    path: "/EditUser/:userId",
    name: "ویرایش کاربر",
    component: UserForm,
    meta: {
      new: false,
      group: routeGroup.users
    }
  },
  {
    path: "/UserAccessGroups/:userId",
    name: "نقش های کاربر",
    component: UserAccessGroups,
    meta: {
      group: routeGroup.users
    }
  },
  {
    path: "/ChangeUserPass/:userId",
    name: "تغییر رمز عبور کاربر",
    component: UserRepassForm,
    meta: {
      group: routeGroup.users
    }
  },
  {
    path: '/users',
    name: 'لیست کاربران',
    component: UserList,
    meta: {
      group: routeGroup.usres
    }
  },

  //Permission
  // {
  //   path: '/permissions',
  //   name: 'لیست دسترسی ها',
  //   component: PermissionList,
  //   meta: {
  //     group: routeGroup.permissions
  //   }
  // },
  // {
  //   path: '/userDetails/:userId',
  //   name: 'اطلاعات کاربر',
  //   component: UserDetails,
  //   meta: {
  //     group: routeGroup.users
  //   }
  // },
  // {
  //   path: "/AddPermission",
  //   name: "تعریف دسترسی جدید",
  //   component: PermissionForm,
  //   meta: {
  //     new: true,
  //     group: routeGroup.permissions
  //   }
  // },
  // {
  //   path: "/EditPermission/:permissionId",
  //   name: "ویرایش دسترسی",
  //   component: PermissionForm,
  //   meta: {
  //     new: false,
  //     group: routeGroup.permissions
  //   }
  // },

  //Company
  {
    path: '/companies',
    name: 'لیست شرکت ها',
    component: CompanyList,
    meta: {
      group: routeGroup.companies
    }
  },
  {
    path: '/addCompany',
    name: 'افزودن شرکت',
    component: CompanyForm,
    meta: {
      new: true,
      group: routeGroup.companies
    }
  },
  {
    path: '/updateCompany/:companyId',
    name: 'ویرایش شرکت',
    component: CompanyForm,
    meta: {
      new: false,
      group: routeGroup.companies
    }
  },

  //Customer
  {
    path: '/customers',
    name: 'لیست مشتری ها',
    component: CustomerList,
    meta: {
      group: routeGroup.customers
    }
  },
  {
    path: '/addCustomer',
    name: 'افزودن مشتری',
    component: CustomerForm,
    meta: {
      new: true,
      group: routeGroup.customers
    }
  },
  {
    path: '/updateCustomer/:customerId',
    name: 'ویرایش مشتری',
    component: CustomerForm,
    meta: {
      new: false,
      group: routeGroup.customers
    }
  },

  //Company Section
  {
    path: '/addSection/:companyId',
    name: 'افزودن بخش',
    component: CompanySectionForm,
    meta: {
      new: true,
      group: routeGroup.sections
    }
  },
  {
    path: '/sections/:companyId',
    name: 'لیست بخش ها',
    component: CompanySectionList,
    meta: {
      group: routeGroup.sections
    }
  },
  {
    path: '/manageSectionCustomers',
    name: 'مدیریت دسترسی مشتریان به بخش',
    component: SectionCustomerManager,
    meta: {
      group: routeGroup.sections
    }
  },
  {
    path: '/CustomerReferTargetManager',
    name: 'مدیریت دریافت کنندگان تیکت',
    component: CompanyReferralBaseForm,
    meta: {
      group: routeGroup.sections
    }
  },
  {
    path: '/updateSection/:sectionId',
    name: 'ویرایش بخش',
    component: CompanySectionForm,
    meta: {
      new: false,
      group: routeGroup.sections
    }
  },

  //Role
  {
    path: '/addRole/:companyId',
    name: 'تعریف نقش جدید',
    component: RoleForm,
    meta: {
      new: true,
      group: routeGroup.roles
    }
  },
  {
    path: '/roles/:companyId',
    name: 'لیست نقش ها',
    component: RoleList,
    meta: {
      group: routeGroup.roles
    }
  },
  {
    path: '/updateRole/:roleId',
    name: 'ویرایش نقش',
    component: RoleForm,
    meta: {
      new: false,
      group: routeGroup.roles
    }
  },
  {
    path: '/copyRole/:roleId',
    name: 'رو‌نویسی از نقش',
    component: RoleForm,
    meta: {
      copy: true,
      group: routeGroup.roles,
    }
  },
  {
    path: '/roleUsers/:roleId',
    name: 'مدیریت اعضای نقش',
    component: UserRoleForm,
    meta: {
      group: routeGroup.roles
    }
  },

  //End base forms


  //person route
  {
    path: "/profile",
    name: "پروفایل من",
    component: Profile,
  },
  // {
  //   path: "/school",
  //   name: "اطلاعات آموزشگاه ها",
  //   component: School,
  //   meta: {
  //     group: routeGroup.school
  //   }
  // },
  // {
  //   path: "/schoolActivity",
  //   name: "اطلاعات فعالیت ها",
  //   component: SchoolActivity,
  //   meta: {
  //     group: routeGroup.school
  //   }
  // },

  //permission route
  // {
  //   path: "/userAccessGroup-manager",
  //   name: "مدیریت نقش",
  //   component: AccessGroupManager,
  // },
  // {
  //   path: "/userAccessGroup-add",
  //   name: "افزودن نقش",
  //   component: AccessGroupAdd,
  // },
  // {
  //   path: "/userAccessGroup-edit/:id",
  //   name: "ویرایش   نقش",
  //   component: AccessGroupEdit
  // },


  {
    path: "/signin",
    name: "ورود به سامانه",
    component: Signin
  },
  {
    path: "/signout",
    name: "خروج",
    component: Signout
  },
  {
    path: "/reportResultDoctor"
  },
  //{
  //  path: '/:pathMatch(.*)*',
  //  redirect: "/"
  //}//,
  //{
  //    path: '/:NotFound(.*)*',
  //    component: NotFound        
  //}

];

const router = createRouter({
  mode: "history",
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  },
  history: createWebHistory(process.env.BASE_URL),
  // history: createWebHistory(),
  //base: process.env.BASE_URL,
  routes,
  linkActiveClass: "active",
  //mode: 'abstract'
});

router.beforeEach(async (to, from, next) => {
  //console.log(`Navigating to: ${to.name}`);
  //console.log(to);
  //console.log(from);
  //console.log(next);

  store.state.routeHistory.push(from);
  store.state.lastRoute = from.path;

  let isAuthenticated = checkAuthentication();

  if (!isAuthenticated && to.path != '/Signin') {
    next('/Signin');
  }
  else if (isAuthenticated && to.path == '/Signin') {
    next('/main');
  }
  else {
    next();
  }
});

function checkAuthentication() {
  try {
    restoreUserInfo().then(() => {
      restoreNotifications();
    });
    if (store.state.currentUserInfo.token) {
      return true;
    }
    else {
      return false;
    }
    //return store.state.currentUserInfo.id && store.state.currentUserInfo.id > 0;
  }
  catch { return false; }
}

async function restoreUserInfo() {
  let data = {};
  try {
    if (store.state.currentUserInfo.token == null ||
      store.state.currentUserInfo.userId == 0) {

      data = localStorage.getItem('user_info');
      if (data != undefined && data != null) {
        store.state.currentUserInfo = JSON.parse(data);
      }
    }
  }
  catch (e) {
    console.log(e);
  }
}

function restoreNotifications() {
  let referralNotifications = localStorage.getItem("newReferralNotifications");
  let myTicketsNotifications = localStorage.getItem("myTicketsNotifications");

  // let notifications = [];

  if (referralNotifications != undefined & referralNotifications != null)
    store.dispatch('addListNewReferralNotifications', JSON.parse(referralNotifications));
    // notifications = JSON.parse(referralNotifications);

  if (myTicketsNotifications != undefined & myTicketsNotifications != null)
    store.dispatch('addListMyTicketsNotifications', JSON.parse(myTicketsNotifications));
    // notifications = [...notifications, ...JSON.parse(myTicketsNotifications)];
  
  // store.dispatch("addListNewNotifications", notifications);
}

export default router;
